import React, { useState, useEffect, useMemo } from "react";
import ChainIcon from "../../../Icons/chain.png";
import BrokenIcon from "../../../Icons/broken-link.png";
import BrowseImageIcon from "../../../Icons/browse-images.png";
import ExternalLinkIcon from "../../../Icons/external-link.png";
import axios from "axios";
import { useSelector } from "react-redux";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Select from 'react-select';
import Loader from "../CommonLoader";
import { datezonechange, removeDuplicateDate } from "../Commonfun"
import searchEngine from "../Asset/ESO/search-engine.svg";
import Invalid_Linkssvg from "../Asset/esocardicon/ExternalLinks/Invalid_Links.svg"
import VideoLinkssvg from "../Asset/esocardicon/ExternalLinks/VideoLinks.svg"
import TotalExternalLinkssvg from "../Asset/esocardicon/ExternalLinks/TotalExternalLinks.svg"
import RootDomainsLinkedsvg from "../Asset/esocardicon/ExternalLinks/RootDomainsLinked.svg"
import { Tooltip } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate } from "react-router-dom";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import { Container, Grid, Box } from '@mui/material';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import { Breadcrumbs, Typography } from "@mui/material";
import Chart from "react-apexcharts";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorIcon from '@mui/icons-material/Error';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Card,
  CardContent,
  Chip
} from "@mui/material";
const ExternalLinkListData = (props) => {
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const rows = cardData ?? [];
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [TotalExternalLinks, SetTotalExternalLinks] = useState(0)
  const [InvalidLinks, SetInvalidLinks] = useState(0)
  const [ImageVideoLinks, SetImageVideoLinks] = useState(0)
  const [RootDomainsLinks, SetRootDomainsLinks] = useState(0)
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState("");
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [tableLoading, setTableLoading] = useState(true);
  const [externallinkcount, setExternallinkcount] = useState([]);
  const [distributionCount, setDistributionCount] = useState([]);
  const [contentbreakcount, setContentbreakcount] = useState([]);
  const [contentbreakcountlabel, setContentbreakcountlabel] = useState([]);
  const [contenttrends, setContenttrends] = useState([]);
  const [typedata, setTypedata] = useState([]);
  const [healthdata, setHealthdata] = useState([]);
  const [visibleCount, setVisibleCount] = useState(3);



  const visibleItems = typedata.slice(0, visibleCount);

  const donutChartLabel = ['Healthy Links', 'Invalid Links', 'Media Links', 'Redirect Links', 'Root Domains', 'Server Error Links'];
  const distributionlabel = ['2XX', '3XX', '4XX', '5XX'];


  const navigate = useNavigate();

  const [validation, setValidation] = useState({
    dateerror: "",
  });
  const [dEngineoption, SetdEngineoption] = useState({
    completed_at:
      'Select Date',
    value:
      'Select Date',
  });


  const [prevdEngineoption, setprevdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        setVisibleCount(prev => prev + 1);
      }
    };
  });
  const columns = [
    {
      field: "url",
      headerName: "URL",
      minWidth: 400,
      flex: 1,
      headerAlign: "center",
      align: "center",
      description: "External web page URL of the domain",
      renderCell: (cardData) => {

        let baseUrl = cardData.row.url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.url.split("/").slice(3).join("/");

        return (
          <>
            <Tooltip title={cardData.row.url}>
              <div className="prefered_url_external02">
                <a className="table_links" target="_blank" href={cardData.row.url} style={{ display: 'flex', flexDirection: 'column' }} >
                  <span className="spanlink" style={{ color: "#044792" }} >
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }}>{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </>
        );

      },
    },
    {
      field: "external_url",
      headerName: "External URL",
      description: 'External links are present on the web page.',
      minWidth: 400,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {

        let baseUrl = cardData.row.external_url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.external_url.split("/").slice(3).join("/");

        return (
          <>
            <Tooltip title={cardData.row.external_url}>
              <div className="prefered_url_external02">
                <a className="table_links" target="_blank" href={cardData.row.external_url} style={{ display: 'flex', flexDirection: 'column' }} >
                  <span className="spanlink" style={{ color: "#044792" }} >
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }}>{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </>
        );

      },
    },
    {
      field: "content_type",
      headerName: "Content Type",
      description: 'It displays the content type of the external link',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",

    },
    {
      field: "anchor_text",
      headerName: "Anchor Text",
      description: 'Anchor text used in the web page for linking the external link',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",

    },
    {
      field: "status_code",
      headerName: "Status Code",
      description: "Codes are generated by the server in response to the client's request.",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];

  const FetchExternalLinkList = async (jobid = '') => {
    setLoading(true);
    setTableLoading(true);
    SetTotalExternalLinks(0)
    SetInvalidLinks(0)
    SetImageVideoLinks(0)
    SetRootDomainsLinks(0)
    let domainsecdata = props.Domainsectiondata ? props.Domainsectiondata : "";
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}technical/external_links/?job_id=${jobid}&user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${domainsecdata}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data) {
        if (datavalue?.data?.links_data) {
          SetAutoheightval(false)
          const newData = datavalue?.data?.links_data.map((obj, index) => {
            return { ...obj, sid: index + 1 };
          });
          setCardData(newData);
        }
        setLoading(false);
      }
      else {
        setCardData("");
        SetAutoheightval(true)
        setLoading(false);
      }

      props.SetjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));

    } catch (err) {
      console.log('err', err)
    }
    try {

      const datavaluecard = await axios.get(
        `${process.env.REACT_APP_API_URL}technical/external_links_count/?job_id=${jobid}&user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${props.Domainsectiondata}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

      if (datavaluecard?.data) {
        console.log('externallinkcount', datavaluecard?.data?.health)
        const countlabels = Object.keys(datavaluecard?.data?.content_breakdown).map(
          key => key.charAt(0).toUpperCase() + key.slice(1)
        );
        setContentbreakcountlabel(countlabels)
        // Dynamic values
        const countseries = Object.values(datavaluecard?.data?.content_breakdown);
        setHealthdata(datavaluecard?.data?.health || []);
        setTypedata(datavaluecard?.data?.suggestions?.items)
        setContenttrends(datavaluecard?.data?.trends?.history || [])
        setContentbreakcount(countseries)
        setDistributionCount(datavaluecard?.data?.distribution)
        setExternallinkcount(datavaluecard?.data?.counts)
        SetTotalExternalLinks(datavaluecard?.data?.total_external_url_count)
        SetInvalidLinks(datavaluecard?.data?.total_invalid_links)
        SetImageVideoLinks(datavaluecard?.data?.total_image_and_video_links)
        SetRootDomainsLinks(datavaluecard?.data?.total_root_domains_linked)
      }

    } catch (err) {
      console.log('err', err)
    }


    props.setIsOpen(false);
    setTableLoading(false);
    setLoading(false);
  };

  const applyInstantReport = () => {
    if (props.instantReport) {
      if (props.instantReport?.external_links) {
        const newData = props.instantReport?.external_links.map((obj, index) => {
          return { ...obj, sid: index + 1, external_url: props.instantReport.url };
        });
        setCardData(newData);
      }
    };
  }


  const CloseModalTrigger = () => {
    var errors = {}
    setValidation(errors)
    props.setIsOpen(false)
    SetdEngineoption(prevdEngineoption);
  }

  const FetchCompetitorList = () => {
    var errs = 1;
    let errors = {};
    if (selectval == "") {
      errors.dateerror = "This field is required.";
      errs = 2;
    } else {
      errors.dateerror = "";
      errs = 1;
      setValidation(errors);
    }
    if (errs == 2) {
      return setValidation(errors);
    }
    setprevdEngineoption(dEngineoption);
    FetchExternalLinkList(selectval)
  }

  const FetchJobDates = async () => {
    try {
      const completevalues = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?job_type=link_checker&user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (completevalues?.data?.jobs.length > 0) {
        const uniqueByCompletedAt = removeDuplicateDate(completevalues?.data?.jobs);
        setcompletedate(uniqueByCompletedAt)
        setSelectval(uniqueByCompletedAt[0]?.value)
        SetdEngineoption(uniqueByCompletedAt[0])
        setprevdEngineoption(uniqueByCompletedAt[0]);
      }

    } catch (err) {
      console.log('err', err)
    }
  }
  const apihandleClose = () => {

    setapiOpen(false);
  };
  useEffect(() => {
    if (props.reportStatus) {
      applyInstantReport();
    } else {
      FetchExternalLinkList();
    }
    FetchJobDates()
  }, [props.Domainsectiondata, props.instantReport]);

  const cardDatas = [
    {

      value: TotalExternalLinks || 0,
      title: "Total External Links",
      badge: "LINKS",
      iconSrc: TotalExternalLinkssvg,
      iconColor: 1,
      bgColor: 1,

    },
    {

      value: InvalidLinks || 0,
      title: "Invalid Links",
      badge: "ERRORS",
      iconSrc: Invalid_Linkssvg,
      iconColor: 2,
      bgColor: 2,

    },
    {

      value: ImageVideoLinks || 0,
      title: "Image/Video Links",
      badge: "MEDIA",
      iconSrc: VideoLinkssvg,
      iconColor: 3,
      bgColor: 3,

    },
    {

      value: RootDomainsLinks || 0,
      title: "Root Domains Linked",
      badge: "DOMAINS",
      iconSrc: RootDomainsLinkedsvg,
      iconColor: 4,
      bgColor: 4,

    },

  ];

  function handleReset() {
    SetdEngineoption("");
    setSelectval("");
  }

  return (
    <>
      {
        loading === true ? <Loader /> : null
      }
      {!props.reportStatus &&
        <Container maxWidth={false} className="dashboard-card-container">
          <Box >
            <Grid container className="dashboard-box-card">
              <Grid container spacing={3} justifyContent="center">
                {cardDatas.map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={item.id}>
                    <Commoncard
                      item={item}
                      nonclikable={true}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Container>
      }
      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Link Distribution</Typography>
              <Chart
                type="donut"
                height={240}
                series={[
                  externallinkcount?.healthy_links || 0,
                  externallinkcount?.invalid_links || 0,
                  externallinkcount?.media_links || 0,
                  externallinkcount?.redirect_links || 0,
                  externallinkcount?.root_domains || 0,
                  externallinkcount?.server_error_links || 0
                ]}
                options={{
                  labels: donutChartLabel,
                  colors: [
                    '#2e7d32',
                    '#4caf50',
                    '#ffb74d',
                    '#ffeb3b',
                    '#fb8c00',
                    '#e53935',
                    '#b71c1c'
                  ],
                  legend: {
                    position: 'bottom',
                    fontSize: '10px'
                  },
                  dataLabels: {
                    enabled: false
                  }
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Link Status Code Distribution</Typography>
              <Chart
                type="bar"
                height={250}
                series={[
                  {
                    name: 'Count',
                    data: [
                      distributionCount?.['2xx'] || 0,
                      distributionCount?.['3xx'] || 0,
                      distributionCount?.['4xx'] || 0,
                      distributionCount?.['5xx'] || 0
                    ]
                  }
                ]}
                options={{
                  chart: {
                    toolbar: {
                      show: false
                    }
                  },
                  plotOptions: {
                    bar: {
                      horizontal: true,
                      borderRadius: 4,
                      barHeight: '45%'
                    }
                  },
                  colors: ['#1976d2'],
                  dataLabels: {
                    enabled: true
                  },
                  xaxis: {
                    categories: distributionlabel,
                    labels: {
                      // rotate: -45,
                      offsetX: -150
                    }
                  },
                  grid: {
                    borderColor: '#e0e0e0'
                  },
                  tooltip: {
                    y: {
                      formatter: value => `${value} Links`
                    }
                  }
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                Link Type Distribution
              </Typography>
              <Chart
                type="pie"
                height={250}
                series={contentbreakcount}
                options={{
                  labels: contentbreakcountlabel,
                  colors: ['#1976d2', '#ff9800', '#e53935'],
                  legend: {
                    position: 'bottom'
                  },
                  dataLabels: {
                    enabled: true,
                    formatter: function (val, opts) {
                      const label = opts.w.config.labels[opts.seriesIndex];
                      const value = opts.w.config.series[opts.seriesIndex];

                      return `${label}: ${value}`;
                    }
                  },
                  tooltip: {
                    y: {
                      formatter: value => `${value}`
                    }
                  }
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} md={4}>
            <Box
              className="grid_table_shodow"
              style={{
                padding: '15px',
                height: '300px',
                marginTop: '10px'
              }}
            >
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 'bold',
                  marginBottom: '10px'
                }}
              >
                Weekly Score Trend
              </Typography>

              <Chart
                type="area"
                height={220}
                series={[
                  {
                    name: "Total",
                    data: contenttrends?.map(i => i.total) || []
                  }
                ]}
                options={{
                  chart: {
                    toolbar: {
                      show: false
                    }
                  },

                  colors: ["#ff601f"],

                  stroke: {
                    curve: 'smooth',
                    width: 3
                  },

                  fill: {
                    type: 'gradient',
                    gradient: {
                      shadeIntensity: 1,
                      opacityFrom: 0.4,
                      opacityTo: 0.1
                    }
                  },

                  xaxis: {
                    categories:
                      contenttrends?.map(i =>
                        new Date(i.date).toLocaleDateString('en-IN', {
                          month: 'short',
                          day: 'numeric'
                        })
                      ) || [],

                    // tickPlacement: 'on',

                    labels: {
                      // rotate: -45,
                      offsetX: 50
                    }
                  },

                  yaxis: {
                    min: 0,
                    max: Math.max(
                      ...(contenttrends?.map(i => i.total) || [0])
                    ) + 100
                  },

                  dataLabels: {
                    enabled: false
                  },

                  grid: {
                    padding: {
                      left: 10,
                      right: 10
                    }
                  },

                  tooltip: {
                    y: {
                      formatter: value => `${value}`
                    }
                  }
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box
              className="grid_table_shodow"
              style={{
                padding: '12px',
                height: '310px',
                overflowY: 'auto'
              }}
            >
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 600,
                  marginBottom: '12px'
                }}
              >
                Recommendations
              </Typography>

              {visibleItems.map((item, index) => {
                const typeStyles = {
                  critical: {
                    border: '#e53935',
                    bg: '#ffebee',
                    color: '#c62828'
                  },
                  warning: {
                    border: '#fb8c00',
                    bg: '#fff3e0',
                    color: '#ef6c00'
                  },
                  improvement: {
                    border: '#43a047',
                    bg: '#e8f5e9',
                    color: '#2e7d32'
                  }
                };

                const current = typeStyles[item.type];

                return (
                  <Card
                    key={index}
                    style={{
                      marginBottom: '10px',
                      borderLeft: `4px solid ${current.border}`,
                      borderRadius: '10px',
                      boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
                    }}
                  >
                    <CardContent style={{ padding: '12px' }}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="flex-start"
                        gap={1}
                      >
                        <Box>
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: 600,
                              marginBottom: '4px',
                              lineHeight: 1.4
                            }}
                          >
                            {item.message}
                          </Typography>

                          <Typography
                            variant="caption"
                            style={{
                              color: '#666',
                              lineHeight: 1.5
                            }}
                          >
                            {item.action}
                          </Typography>
                        </Box>

                        <Chip
                          label={item.type}
                          size="small"
                          style={{
                            background: current.bg,
                            color: current.color,
                            fontWeight: 600,
                            textTransform: 'capitalize',
                            fontSize: '11px'
                          }}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                );
              })}
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              className="grid_table_shodow"
              style={{
                height: "310px",
                padding: "10px"
              }}
            >
              <Typography
                variant="h6"
                style={{
                  color: "#000",
                  fontWeight: "bold",
                  textAlign: "center"
                }}
              >
                Total Vital Score
              </Typography>

              {(() => {
                const status = healthdata?.status
                  ?.toLowerCase()
                  ?.replaceAll("_", " ");

                const statusConfig = {
                  excellent: {
                    color: "#22c55e",
                    label: "Excellent"
                  },
                  good: {
                    color: "#3b82f6",
                    label: "Good"
                  },
                  "need improvement": {
                    color: "#f59e0b",
                    label: "Need Improvement"
                  },
                  "needs improvement": {
                    color: "#f59e0b",
                    label: "Need Improvement"
                  },
                  critical: {
                    color: "#ef4444",
                    label: "Critical"
                  }
                };

                const currentStatus = statusConfig[status] || {
                  color: "#999",
                  label: "Unknown"
                };

                return (
                  <>
                    <Chart
                      type="radialBar"
                      height={240}
                      series={[healthdata?.score || 0]}
                      options={{
                        colors: [currentStatus.color],
                        chart: {
                          sparkline: {
                            enabled: true
                          }
                        },
                        plotOptions: {
                          radialBar: {
                            hollow: {
                              size: "70%"
                            },
                            track: {
                              background: "#f2f2f2"
                            },
                            dataLabels: {
                              name: {
                                show: false
                              },
                              value: {
                                fontSize: "28px",
                                fontWeight: "bold",
                                color: currentStatus.color,
                                offsetY: 10,
                                formatter: function (val) {
                                  return Number(val);
                                }
                              }
                            }
                          }
                        },
                        stroke: {
                          lineCap: "round"
                        }
                      }}
                    />

                    {/* Status Text */}
                    <Typography
                      variant="h6"
                      style={{
                        textAlign: "center",
                        marginTop: "-15px",
                        fontWeight: "bold",
                        color: currentStatus.color
                      }}
                    >
                      {currentStatus.label}
                    </Typography>
                  </>
                );
              })()}
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  tableLoading={tableLoading}
                  handleModelPopUp={props.handleModelPopUp}
                  handleDownlodingCSV={props.handleDownlodingCSV}
                  handleDownlodingPDF={props.handleDownlodingPDF}
                  customFilter={!props.reportStatus}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                  DownloadShowFile={!props.reportStatus}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Dialog
        open={props.modalIsOpen}
        onClose={CloseModalTrigger}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">

              <div>

                <div className="">
                  <div>
                    <span>Completed Date</span>
                    <Select
                      value={dEngineoption}
                      placeholder="Select Date"
                      options={completedate}
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectval(values.value)
                        props.setJobIdvalue(values.value)
                        SetdEngineoption(values);
                        setValidation({
                          dateerror: "",
                        })
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>


                </div>
                <span className="text-error">{validation.dateerror}</span>
              </div>

            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button className="form_submit_btn" onClick={FetchCompetitorList} style={{ cursor: 'pointer' }} >
            Submit
          </button>
          <button style={{ cursor: 'pointer' }} onClick={CloseModalTrigger}>Close</button>
          <button style={{ cursor: 'pointer' }} onClick={handleReset}>Reset</button>
        </DialogActions>
      </Dialog>
      {!props.openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
      <UserActivityTracker pagename="Technical - Links - External Links" />
    </>
  );
};

export default ExternalLinkListData;
